import React from "react";

import { HubContextMenu } from "../../components";
import { useHubSnackBar } from "../../hooks";

const MENU_ITEMS = [
  {
    id: "edit",
    label: "Edit Route Schedule",
    icon: "Calendar",
  },
  {
    id: "create",
    label: "Create Labor Ticket",
    icon: "User",
  },
  // {
  //   id: "complete",
  //   label: "Mark as Complete",
  //   icon: "CheckCircle",
  //   color: "greenMain",
  // },
  // {
  //   id: "clear",
  //   label: "Clear All Labor",
  //   icon: "XCircle",
  //   color: "redError",
  // },
];

export const WorkOrderContextMenu = ({
  id,
  setRouteId = () => {},
  setEditId = () => {},
  started,
  ended,
  routeId,
  ...rest
}) => {
  const { addSnackbarError } = useHubSnackBar();
  const message =
    "This route has been started or completed and cannot be changed";
  const addMessage = "Please save the route before adding labor tickets";

  const onSelect = (item) => {
    switch (item?.id) {
      case "edit":
        if (started || ended) addSnackbarError({ message });
        else if (routeId)
          setEditId((prev) => (prev === routeId ? null : routeId));
        break;
      case "create":
        if (routeId) setRouteId(routeId);
        else addSnackbarError({ message: addMessage });
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={"contacts"}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { padding: "0px" } }}
      HubIconProps={{ size: 14 }}
      {...rest}
    />
  );
};

export default WorkOrderContextMenu;
